import routes from "../../../../../core/services/common/api-routes"
import {HttpAuthGet, HttpAuthPost, HttpAuthPut, HttpAuthDelete, HttpAuthPutParamsPayload} from "../../../../../core/services/common/HttpRequestBuilder"

const listAllPermissions = () => {

    let result = HttpAuthGet(routes.LIST_ALL_PERMISSSIONS, null);
    return result;
}

const listPermissions = () => {

    let result = HttpAuthGet(routes.LIST_PERMISSIONS, null);
    return result;
}

const createPermission = (payload) => {

    let result = HttpAuthPost(routes.CREATE_PERMISSION, payload);
    return result;
}

const updatePermission = (parameters, payload) => {

    let result = HttpAuthPutParamsPayload(routes.UPDATE_PERMISSION, parameters, payload);
    return result;
}

const updatePermissionModule = (parameters) => {

    let result = HttpAuthPut(routes.UPDATE_PERMISSION_MODULE, parameters);
    return result;
}


const deletePermission = (parameters) => {

    let result = HttpAuthDelete(routes.DELETE_PERMISSION, parameters);
    return result;
}

const PermissionService = {
    listAllPermissions,
    listPermissions,
    createPermission,
    updatePermission,
    updatePermissionModule,
    deletePermission
}

export default PermissionService
